import { api } from "@ts/core/api";
import { Cookie } from "@ts/core/Cookie";
import { Elements } from "@ts/core/Elements";
import { simpleForm } from "@ts/core/SimpleForm";
import { StreamsData } from "@ts/data/StreamsData";
import { YoutubeSection } from "@ts/sections/YoutubeSection";

export function createYoutubeSection(): Promise<boolean> {

    return new Promise((resolve) => {
        simpleForm('Youtube', 1, 'Klistra in din Youtube-länk', '',
            'Youtube-länk här')
            .then(
                async (text: string) => {
                    const data = new Object as StreamsData;
                    data.sharedcode = text;
                    data.sectiontype = 'streams';
                    data.subtype = 'youtube';
                    data.public = false;
                    data.streaminid = 0;
                    data.sectionid = 0;
                    const resp = await api<{ data: StreamsData }>('createSection', {
                        pos: Elements.contentContainer.childElementCount,
                        pagename: Cookie.pagename,
                        data: data,
                        type: 'youtube'
                    });
                    if (resp) {
                        const section = new YoutubeSection(resp.data);
                        section.render();
                        section.enableEdit = true;
                        section.beginEdit();
                        resolve(true);
                    }
                },
                () => {
                    resolve(false);
                }
            );
    });
}

